module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    ref: "badge",
    style: (_vm.styles)
  }, [_vm._t("default"), _vm._v(" "), (_vm.count) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.badge),
      expression: "badge"
    }],
    class: _vm.countClasses
  }, [_vm._v(_vm._s(_vm.finalCount))]) : (_vm.dot) ? _c('span', {
    class: _vm.countClasses
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6593999c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/badge/badge.vue
// module id = 375
// module chunks = 0